"use strict";

exports.__esModule = true;
exports.default = void 0;
function toRadians(angle) {
  return angle * (Math.PI / 180);
}
function getScaleFactorThatRemovesDarkCorners(w, h, granularAngle) {
  var α = Math.abs(toRadians(granularAngle));
  var scaleFactor = Math.max((Math.sin(α) * w + Math.cos(α) * h) / h, (Math.sin(α) * h + Math.cos(α) * w) / w);
  return scaleFactor;
}
var _default = exports.default = getScaleFactorThatRemovesDarkCorners;